import { createSlice } from '@reduxjs/toolkit';
// utils
import axios from '../../utils/axios';
//
import { dispatch } from '../store';


const initialState = {
    isLoading: false,
    error: null,
    saveResumeData: [],
    professionThemesData: [],
    professionDataSucc: [],
    isOpenModal: false,
    selectedEventId: null,
    selectedRange: null,
  };

  const slice = createSlice({
    name: 'Resume',
    initialState,
    reducers: {
      // START LOADING
      startLoading(state) {
        state.isLoading = true;
      },
      
      // HAS ERROR
      hasError(state, action) {
        state.isLoading = false;
        state.error = action.payload;
      },
      
      professionThemesSucc(state, action) {
        state.isLoading = false;
        state.professionThemesData = action.payload;
      },
      professionSucc(state, action) {
        state.isLoading = false;
        state.professionDataSucc = action.payload;
      },
      createResumeSucc(state, action) {
        state.isLoading = false;
        state.saveResumeData = action.payload;
       },
    },
  });

  // Reducer
export default slice.reducer;

// Actions
export const { openModal, closeModal, selectEvent } = slice.actions;


  export function getProfessionThemeData(data) {
    return async () => {
      dispatch(slice.actions.startLoading());
      try {
        const response = await axios.post('/get_themes/',data);
        if(response && response.data && response.data.status === 200 ){
          dispatch(slice.actions.professionThemesSucc(response.data));
        }else{
          dispatch(slice.actions.hasError(response.data))
        }
      } catch (error) {
       if((error && error.status !== "") && (error.status !== undefined) ){
        dispatch(slice.actions.hasError(error));
      } else{
        dispatch(slice.actions.hasError({status:"502",message:"Something went wrong"}))
      }
      }
    };
  }

  export function getProfessionData(data) {
    return async () => {
      dispatch(slice.actions.startLoading());
      try {
        const response = await axios.post('/get_profession_name/',data);
        if(response && response.data && response.data.status === 200 ){
          dispatch(slice.actions.professionSucc(response.data));
        }else{
          dispatch(slice.actions.hasError(response.data))
        }
      } catch (error) {
       if((error && error.status !== "") && (error.status !== undefined) ){
        dispatch(slice.actions.hasError(error));
      } else{
        dispatch(slice.actions.hasError({status:"502",message:"Something went wrong"}))
      }
      }
    };
  }

  export function clearCreateResume (data) {
    return async () => {
      dispatch(slice.actions.startLoading());
      try {
        dispatch(slice.actions.createResumeSucc([]));
       } catch (error) {
        dispatch(slice.actions.hasError(error));
      }
    };
  }

  export function createResume(data){
    return async ()=>{
      dispatch (slice.actions.startLoading());
      try {
        const response = await axios.post('/create_resume/', data);
        dispatch(slice.actions.createResumeSucc(response.data));
      }catch (error){
        dispatch(slice.actions.hasError(error));
      }
    }
  }